import LineType from './LineType'
import LineRunLocation from './LineRunLocation'
export class FountainInfo {
    RequestID: number;
    RemoveReasonID?: number;
    InstallReasonID?: number;
    LineTypeID: number;
    LineType: LineType;
    LineRunLocationID: number;
    LineRunLocation: LineRunLocation;
    LineRunLength: string;
    NumberOfPumps: number;
    NumberOfBIB2Racks: number;
    NumberOfRegulators: number;
    NumberOfCarbonators: number;
    CabinetStand: boolean;
    LegKit: boolean;
    ProjectedVolume?: number;
    Flavors?: string;
}

export default FountainInfo;